/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetSystemSettingByIdDto } from '../models/custom-result-of-get-system-setting-by-id-dto';
import { CustomResultOfIEnumerableOfKeyValuePairOfIntegerAndString } from '../models/custom-result-of-i-enumerable-of-key-value-pair-of-integer-and-string';
import { CustomResultOfPaginatedListOfGetSystemSettingsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-system-settings-with-pagination-dto';
import { systemSettingsCreateGet } from '../fn/system-settings/system-settings-create-get';
import { SystemSettingsCreateGet$Params } from '../fn/system-settings/system-settings-create-get';
import { systemSettingsCreatePost } from '../fn/system-settings/system-settings-create-post';
import { SystemSettingsCreatePost$Params } from '../fn/system-settings/system-settings-create-post';
import { systemSettingsDelete } from '../fn/system-settings/system-settings-delete';
import { SystemSettingsDelete$Params } from '../fn/system-settings/system-settings-delete';
import { systemSettingsGetSystemSettingsAudit } from '../fn/system-settings/system-settings-get-system-settings-audit';
import { SystemSettingsGetSystemSettingsAudit$Params } from '../fn/system-settings/system-settings-get-system-settings-audit';
import { systemSettingsGetSystemSettingsTypeList } from '../fn/system-settings/system-settings-get-system-settings-type-list';
import { SystemSettingsGetSystemSettingsTypeList$Params } from '../fn/system-settings/system-settings-get-system-settings-type-list';
import { systemSettingsGetSystemSettingsWithPagination } from '../fn/system-settings/system-settings-get-system-settings-with-pagination';
import { SystemSettingsGetSystemSettingsWithPagination$Params } from '../fn/system-settings/system-settings-get-system-settings-with-pagination';
import { systemSettingsUpdateGet } from '../fn/system-settings/system-settings-update-get';
import { SystemSettingsUpdateGet$Params } from '../fn/system-settings/system-settings-update-get';
import { systemSettingsUpdatePut } from '../fn/system-settings/system-settings-update-put';
import { SystemSettingsUpdatePut$Params } from '../fn/system-settings/system-settings-update-put';

@Injectable({ providedIn: 'root' })
export class SystemSettingsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `systemSettingsGetSystemSettingsAudit()` */
  static readonly SystemSettingsGetSystemSettingsAuditPath = '/SystemSettings/GetSystemSettingsAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `systemSettingsGetSystemSettingsAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  systemSettingsGetSystemSettingsAudit$Response(params: SystemSettingsGetSystemSettingsAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return systemSettingsGetSystemSettingsAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `systemSettingsGetSystemSettingsAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  systemSettingsGetSystemSettingsAudit(params: SystemSettingsGetSystemSettingsAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.systemSettingsGetSystemSettingsAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `systemSettingsGetSystemSettingsWithPagination()` */
  static readonly SystemSettingsGetSystemSettingsWithPaginationPath = '/SystemSettings/GetSystemSettingsWithPagination';

  /**
   * Get System Settings with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `systemSettingsGetSystemSettingsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  systemSettingsGetSystemSettingsWithPagination$Response(params: SystemSettingsGetSystemSettingsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetSystemSettingsWithPaginationDto>> {
    return systemSettingsGetSystemSettingsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get System Settings with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `systemSettingsGetSystemSettingsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  systemSettingsGetSystemSettingsWithPagination(params: SystemSettingsGetSystemSettingsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetSystemSettingsWithPaginationDto> {
    return this.systemSettingsGetSystemSettingsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetSystemSettingsWithPaginationDto>): CustomResultOfPaginatedListOfGetSystemSettingsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `systemSettingsGetSystemSettingsTypeList()` */
  static readonly SystemSettingsGetSystemSettingsTypeListPath = '/SystemSettings/GetSystemSettingsTypeList';

  /**
   * Get System Settings Type List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `systemSettingsGetSystemSettingsTypeList()` instead.
   *
   * This method doesn't expect any request body.
   */
  systemSettingsGetSystemSettingsTypeList$Response(params?: SystemSettingsGetSystemSettingsTypeList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfIEnumerableOfKeyValuePairOfIntegerAndString>> {
    return systemSettingsGetSystemSettingsTypeList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get System Settings Type List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `systemSettingsGetSystemSettingsTypeList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  systemSettingsGetSystemSettingsTypeList(params?: SystemSettingsGetSystemSettingsTypeList$Params, context?: HttpContext): Observable<CustomResultOfIEnumerableOfKeyValuePairOfIntegerAndString> {
    return this.systemSettingsGetSystemSettingsTypeList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfIEnumerableOfKeyValuePairOfIntegerAndString>): CustomResultOfIEnumerableOfKeyValuePairOfIntegerAndString => r.body)
    );
  }

  /** Path part for operation `systemSettingsCreateGet()` */
  static readonly SystemSettingsCreateGetPath = '/SystemSettings/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `systemSettingsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  systemSettingsCreateGet$Response(params?: SystemSettingsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return systemSettingsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `systemSettingsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  systemSettingsCreateGet(params?: SystemSettingsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.systemSettingsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `systemSettingsCreatePost()` */
  static readonly SystemSettingsCreatePostPath = '/SystemSettings/Create';

  /**
   * Create System Setting for SuperAdmin.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `systemSettingsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  systemSettingsCreatePost$Response(params: SystemSettingsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return systemSettingsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create System Setting for SuperAdmin.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `systemSettingsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  systemSettingsCreatePost(params: SystemSettingsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.systemSettingsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `systemSettingsUpdateGet()` */
  static readonly SystemSettingsUpdateGetPath = '/SystemSettings/Update';

  /**
   * Get System Setting by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `systemSettingsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  systemSettingsUpdateGet$Response(params?: SystemSettingsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetSystemSettingByIdDto>> {
    return systemSettingsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get System Setting by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `systemSettingsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  systemSettingsUpdateGet(params?: SystemSettingsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetSystemSettingByIdDto> {
    return this.systemSettingsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetSystemSettingByIdDto>): CustomResultOfGetSystemSettingByIdDto => r.body)
    );
  }

  /** Path part for operation `systemSettingsUpdatePut()` */
  static readonly SystemSettingsUpdatePutPath = '/SystemSettings/Update';

  /**
   * Update System Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `systemSettingsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  systemSettingsUpdatePut$Response(params: SystemSettingsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return systemSettingsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update System Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `systemSettingsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  systemSettingsUpdatePut(params: SystemSettingsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.systemSettingsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `systemSettingsDelete()` */
  static readonly SystemSettingsDeletePath = '/SystemSettings/Delete';

  /**
   * Delete System Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `systemSettingsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  systemSettingsDelete$Response(params?: SystemSettingsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return systemSettingsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete System Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `systemSettingsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  systemSettingsDelete(params?: SystemSettingsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.systemSettingsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
